export default "__VITE_ASSET__fbc9ca4d__"